// extracted by mini-css-extract-plugin
export var active = "_36-2";
export var errorDot = "_36-3";
export var sideNavContainer = "_36-0";
export var sideNavLink = "_36-1";